import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';

const Notification = props => {
  return (
    <Snackbar
      open={props.open}
      message={props.message}
      autoHideDuration={4000}
      style={{ height: 'auto', lineHeight: '28px', padding: 24, whiteSpace: 'pre-line', zIndex: 9999 }}
      onClose={props.closeStatusDisplay}
    />
  );
}

Notification.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  closeStatusDisplay: PropTypes.func.isRequired
};

Notification.defaultProps = {
  open: false,
  message: ''
};

export default Notification;
